export var PickItemType;
(function (PickItemType) {
    PickItemType[PickItemType["NORMAL"] = 1] = "NORMAL";
    PickItemType[PickItemType["KIT"] = 2] = "KIT";
})(PickItemType || (PickItemType = {}));
//# sourceMappingURL=pick-item-type.js.map